import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'importError',
    serviceName: 'shopadmin',
    query: gql`
      query importError($ids: [String]) {
        importError(ids: $ids) {
          import_error_records {
            data {
              id
              title
              barcode
              shop {
                id
              }
              co_price
              me_price
              introtext
              description
              brand_title
              booth_title
              category_title
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'createProduct',
    serviceName: 'admin',
    query: gql`
      mutation createProduct(
        $title: String!
        $barcode: String
        $alias: String
        $icon: String
        $introtext: String
        $fulltext: String
        $images: String
        $link_to: String
        $is_active: Int
        $details: String
        $brand_id: String
        $unit_id: String
        $category_id: String
        $import_error_id: String
        $creator_id: String
      ) {
        createProduct(
          title: $title
          barcode: $barcode
          alias: $alias
          icon: $icon
          introtext: $introtext
          fulltext: $fulltext
          images: $images
          link_to: $link_to
          is_active: $is_active
          details: $details
          brand_id: $brand_id
          unit_id: $unit_id
          category_id: $category_id
          import_error_id: $import_error_id
          creator_id: $creator_id
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
